import { create } from "zustand";
import {createJSONStorage, persist} from 'zustand/middleware'

export const useAuthentication = create(
    persist(
        (set) => ({
            isAuthenticated: false,
            token: null,
            claims: {},

            setToken: (newToken) =>
                set((state) => ({
                    ...state,
                    token: newToken,
                    isAuthenticated: true,
                    claims: (decodeJwt(newToken)).claims,
                })),

            resetToken: () =>
                set((state) => ({
                    ...state,
                    token: null,
                    isAuthenticated: false,
                    claims: {},
                })),


        }),
        {
            name: 'rental-flow-auth', // name in storage
            storage: createJSONStorage(() => localStorage),
        }
    )
)

function decodeJwt(token) {
    const [h64, c64, signature] = token.split('.');
    const jwt = {
        header: (h64) ? JSON.parse(atob(h64)) : null,
        claims: (c64) ? JSON.parse(atob(c64)) : null,
        signature
    }
    return jwt;
}